import { BankSecurityEvent } from '../../models/supplier.model';
import { PayloadAction } from 'app/shared/model/action.model';
import { Event } from '../../models/event.model';

export const POST_EVENT = 'POST_EVENT';
export const CLEAR_EVENT = 'CLEAR_EVENT';
export const POST_EVENT_SUCCESS = 'POST_EVENT_SUCCESS';
export class PostEvent implements PayloadAction {
  readonly type = POST_EVENT;
  constructor(public payload: Event) { }
}
export class ClearEvent implements PayloadAction {
  readonly type = CLEAR_EVENT;
  constructor() { }
}
export class PostEventSuccess implements PayloadAction {
  readonly type = POST_EVENT_SUCCESS;
  constructor(public payload: Event) { }
}

export const GET_SECURITY_EVENT = 'GET_SECURITY_EVENT';
export const GET_SECURITY_EVENT_SUCCESS = 'GET_SECURITY_EVENT_SUCCESS';
export class GetSecurityEvent implements PayloadAction {
  readonly type = GET_SECURITY_EVENT;
  constructor(public payload?) { }
}
export class GetSecurityEventSuccess implements PayloadAction {
  readonly type = GET_SECURITY_EVENT_SUCCESS;
  constructor(public payload: BankSecurityEvent) { }
}

export type EventActions =
  PostEvent | PostEventSuccess
  | ClearEvent
  | GetSecurityEvent | GetSecurityEventSuccess;
